<script lang="ts">
  import type {Notification, User} from '../types'
  import {t, replaceValues} from '../i18n'
  import {Link} from 'svelte5-router'
  import {formatDateTimeRelative} from '../utils/format'

  export let notificationParams: {
    collection_id: string
    collection_name: string
    follower: User
  }
  export let notification: Notification

  $: follower = notificationParams.follower
</script>

<div class="item">
  <Link class="notice-img" to={follower.link}>
    <img src={follower.avatar_big_thumgb} alt={follower.full_name}/>
  </Link>
  <Link class="notice-content" to={`/collections/${notificationParams.collection_id}`}>
    <span class="notice-action db">
      {@html replaceValues(t.timelines.collection_followed, {
        user: follower.full_name,
        user_id: follower.handle,
        collection: notificationParams.collection_name,
        collection_id: notificationParams.collection_id,
      })}
    </span>

    <i class="notice-time db">{formatDateTimeRelative(notification.created_at)}</i>
  </Link>
</div>